export function getValueHelper(state: boolean, value: any) {
    return state ? value : undefined;
}